import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GA_MEASUREMENT_ID } from '../../config/api';
import { trackGoogleAnalyticsPageView } from '../../utils/googleAnalytics';

/**
 * Šalje page_view u Google Analytics pri svakoj promeni rute (SPA).
 * Radi na svim stranicama — ne samo na naslovnoj.
 */
const GoogleAnalyticsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;
    trackGoogleAnalyticsPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
};

export default GoogleAnalyticsRouteTracker;
